module.exports = __webpack_public_path__ + "img/spotify-logo.77d708b3.png";